import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import TabbedInterface from './components/TabbedInterface';
import ErrorBoundary from './components/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <TabbedInterface />
    </ErrorBoundary>
  </React.StrictMode>
); 